const empty = {
    object: {},
    array: [],
};
export default empty;
//# sourceMappingURL=empty.js.map